import { Navigate, Outlet } from 'react-router-dom';
import { useCurrentUser } from '@/hooks/use-current-user';
import { FullPageLoader } from 'prosci-ui';

export function LicenseAdminRoute() {
  const { data: currentUser, isLoading } = useCurrentUser();

  if (isLoading) {
    return <FullPageLoader message="Loading..." />;
  }

  // Check if user is a License admin
  const isLicenseAdmin = currentUser?.type === 'license_admin';

  if (!isLicenseAdmin) {
    // Redirect to users page if not a License admin
    return <Navigate to="/users" replace />;
  }

  return <Outlet />;
}
